import getAnalyticsMiddleware from "shared/redux/getAnalyticsMiddleware";

import signup from "analytics/signup";
import login from "analytics/login";
import splash from "analytics/splash";

const analyticsMiddleware = getAnalyticsMiddleware({
	login,
	splash,
	signup,
});

export default analyticsMiddleware;



// WEBPACK FOOTER //
// ./src/pages/loggedout/analyticsMiddleware.js